import ISecondaryPersonalDocument from "@/module/main/dto/customer/ISecondaryPersonalDocument";
import DocumentType from "@/module/main/dto/customer/SecondaryDocumentTypeEnum";
import IIdentificationDocument from "@/module/main/dto/customer/IIdentificationDocument";
import IAcademicIdentificationDocumentFull from "@/module/main/dto/customer/IAcademicIdentificationDocumentFull";

export default class SecondaryPersonalDocument implements ISecondaryPersonalDocument {
    constructor(
        public type?: DocumentType,
        public birthCertificate?: IIdentificationDocument,
        public drivingLicense?: IIdentificationDocument,
        public gunLicense?: IIdentificationDocument,
        public insuranceCard?: IIdentificationDocument,
        public passport?: IIdentificationDocument,
        public academicCard?: IAcademicIdentificationDocumentFull,
    ) {
    }
}
